export default __webpack_public_path__ + "media/images/chevron-left-709d273a63ef49e7f045dfadd457e33e.svg";